/**
 * Analytics configuration.
 *
 * Privacy note: the analytics backend stores ONLY aggregate daily counters
 * (how many signatures were created/copied, template usage, and link-click
 * counts). It never stores email contents, recipients, IP addresses, or any
 * personally identifying information. Reporting is opt-in from the client.
 */

/** Nostr pubkey (hex) allowed to view the admin analytics dashboard. */
export const ADMIN_PUBKEYS: string[] = [
  // BCH Reply Guy — founder
  'df5bcaba9e74cc1764c9773ae160299dde5acf79416e2c96758dba225e6707cc',
];

/** Base path for Netlify Functions. */
export const FN_BASE = '/.netlify/functions';

/** Endpoint the client beacons anonymous aggregate events to. */
export const TRACK_ENDPOINT = `${FN_BASE}/track`;

/** Admin-only stats read endpoint (requires a signed Nostr request). */
export const STATS_ENDPOINT = `${FN_BASE}/stats`;

/** Redirect endpoint for trackable signature links. */
export const REDIRECT_ENDPOINT = `${FN_BASE}/r`;

/** Event types the client is allowed to report. */
export type AnalyticsEventType = 'created' | 'copied' | 'template';

/** Link categories used for click tracking (never the URL itself in stats). */
export type LinkType =
  | 'website'
  | 'email'
  | 'nostr'
  | 'twitter'
  | 'github'
  | 'linkedin'
  | 'telegram'
  | 'instagram'
  | 'bch';

export const LINK_TYPES: LinkType[] = [
  'website',
  'email',
  'nostr',
  'twitter',
  'github',
  'linkedin',
  'telegram',
  'instagram',
  'bch',
];

export function isAdminPubkey(pubkey: string | undefined): boolean {
  return !!pubkey && ADMIN_PUBKEYS.includes(pubkey);
}
